"use strict";
/* globals module */
/**
 * @module articleTagsSubscriptionsRoute
 * @description Baasic Article Tags Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var ArticleTagsSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleTagsSubscriptionsRoute, _super);
    function ArticleTagsSubscriptionsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'article-tags/{id}/subscriptions';
        _this.isSubscribedRoute = 'article-tags/{id}/subscriptions/{subscriberId}';
        _this.unSubscribeRoute = 'article-tags/{id}/subscriptions';
        return _this;
    }
    /**
     * Parses subscribe route which must be expanded with id of the tag.
     * @method
     * @param tag article tag object.
     * @param data The subscribe information.
     * @example articleTagsSubscriptionsRoute.subscribe( {id: '<tag-id>'} );
     **/
    ArticleTagsSubscriptionsRoute.prototype.subscribe = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses isSubscribed route which must be expanded with subscriber id and the id of the tag.
     * @method
     * @param tag Article tag object.
     * @param data The subscriber identifier.
     * @example articleSubscriptionsRoute.isSubscribed({ id: '<tag-id>', subscriberId: '<subscriber-id>' });
     **/
    ArticleTagsSubscriptionsRoute.prototype.isSubscribed = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, params);
    };
    /**
     * Parses unSubscribe route which must be expanded with the id of the article.
     * @method
     * @param tag Article tag object.
     * @param data The unsubscribe information.
     * @example articleUnSubscribeRoute.unSubscribe({id: '<tag-id>'});
     **/
    ArticleTagsSubscriptionsRoute.prototype.unSubscribe = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, params);
    };
    ArticleTagsSubscriptionsRoute.prototype.subscribeParams = function (tag, data) {
        return this.utility.extend(tag, data);
    };
    var _a;
    ArticleTagsSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleTagsSubscriptionsRoute);
    return ArticleTagsSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleTagsSubscriptionsRoute = ArticleTagsSubscriptionsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 
